import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import axios from "axios";
import { categories } from "../data/portfolio";

const API = process.env.REACT_APP_BACKEND_URL;
const TYPES = categories.map((c) => c.label);
const BUDGETS = ["< ₹1L", "₹1–3L", "₹3–6L", "₹6L+", "Let's talk"];

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [types, setTypes] = useState([]);
  const [budget, setBudget] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [errMsg, setErrMsg] = useState("");

  const toggleType = (t) => setTypes((v) => (v.includes(t) ? v.filter((x) => x !== t) : [...v, t]));
  const filled = [name, email, message].filter(Boolean).length + (types.length ? 1 : 0) + (budget ? 1 : 0);
  const remaining = Math.max(0, 5 - filled);

  const submit = async (e) => {
    e.preventDefault();
    if (!name || !email || !message) { setErrMsg("Please add your name, email and a message."); setStatus("error"); return; }
    setStatus("sending"); setErrMsg("");
    try {
      await axios.post(`${API}/api/contact`, { name, email, project_types: types, budget, message });
      setStatus("sent");
    } catch (err) {
      setErrMsg("Something went wrong sending your brief — please try again, or email poonamgarvbaid@gmail.com directly.");
      setStatus("error");
    }
  };

  return (
    <div className="theme-blue min-h-screen page-x pt-28 pb-24 relative overflow-hidden" data-testid="contact-page">
      <Helmet><title>Contact — Poonam Baid | vdesigns.eps</title></Helmet>
      <span className="display absolute -bottom-8 -left-4 pointer-events-none select-none" style={{ fontSize: "28vw", color: "rgba(255,255,255,.06)" }}>vdesigns.eps</span>

      <div className="wrap grid md:grid-cols-2 gap-14 relative">
        {/* left */}
        <div className="min-w-0">
          <h1 className="display" style={{ fontSize: "clamp(2.2rem,8vw,120px)", color: "#fff", overflowWrap: "anywhere" }}>GOT A BRIEF? <span className="serif" style={{ color: "var(--lime)" }}>Let's</span> OPEN A FILE.</h1>
          <p className="lead mt-6" style={{ color: "rgba(255,255,255,.85)" }}>I reply within 2 working days. Tell me what you're making and roughly when.</p>
          <a href="mailto:poonamgarvbaid@gmail.com" className="ul inline-block mt-6" style={{ fontSize: "clamp(1.05rem,5vw,2rem)", color: "#fff", borderBottom: "2px solid var(--lime)", overflowWrap: "anywhere", maxWidth: "100%" }}>poonamgarvbaid@gmail.com</a>
          <div className="grid grid-cols-3 gap-6 mt-10 mono" style={{ color: "rgba(255,255,255,.8)" }}>
            <div><div style={{ color: "var(--lime)" }}>Based</div>Gurugram, IN</div>
            <div><div style={{ color: "var(--lime)" }}>Status</div>Available — Nov 2026</div>
            <div><div style={{ color: "var(--lime)" }}>Elsewhere</div><a href="https://www.linkedin.com/in/poonam-baid" target="_blank" rel="noreferrer" className="ul" style={{ color: "#fff" }}>LinkedIn ↗</a></div>
          </div>
        </div>

        {/* right — file dialog */}
        <div className="rounded-[10px] overflow-hidden" style={{ background: "var(--paper)", color: "var(--ink)", boxShadow: "0 30px 80px rgba(0,0,0,.3)" }}>
          <div className="flex items-center gap-2 px-4 py-3" style={{ background: "var(--paper-2)", borderBottom: "1px solid var(--rule)" }}>
            <span style={{ width: 11, height: 11, borderRadius: 99, background: "#ff5f57" }} />
            <span style={{ width: 11, height: 11, borderRadius: 99, background: "#febc2e" }} />
            <span style={{ width: 11, height: 11, borderRadius: 99, background: "#28c840" }} />
            <span className="mono ml-3" style={{ color: "var(--grey)" }}>untitled-brief.eps</span>
          </div>

          {status === "sent" ? (
            <div className="p-10 text-center" data-testid="contact-success">
              <div className="h2" style={{ fontSize: 40 }}>File saved ✓</div>
              <p className="lead mt-3" style={{ color: "var(--grey)" }}>Your brief is on its way to Poonam. Expect a reply within 2 working days.</p>
              <Link to="/work" className="btn btn--ink mt-6">Back to work →</Link>
            </div>
          ) : (
            <form className="p-6 md:p-8 flex flex-col gap-5" onSubmit={submit}>
              <label className="block">
                <span className="mono" style={{ color: "var(--grey)" }}>Your name</span>
                <input value={name} onChange={(e) => setName(e.target.value)} className="w-full bg-transparent outline-none py-2" style={{ borderBottom: "1px solid var(--rule)", fontSize: 18 }} data-testid="input-name" />
              </label>
              <label className="block">
                <span className="mono" style={{ color: "var(--grey)" }}>Email</span>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent outline-none py-2 focus:border-[var(--blue)]" style={{ borderBottom: "1px solid var(--rule)", fontSize: 18 }} data-testid="input-email" />
              </label>
              <div>
                <span className="mono" style={{ color: "var(--grey)" }}>What are we making?</span>
                <div className="flex flex-wrap gap-2 mt-2">
                  {TYPES.map((t) => (
                    <button type="button" key={t} onClick={() => toggleType(t)} className={`chip ${types.includes(t) ? "chip--active" : ""}`} style={{ height: 32, fontSize: 10 }} data-testid={`type-${t}`}>{t}</button>
                  ))}
                </div>
              </div>
              <div>
                <span className="mono" style={{ color: "var(--grey)" }}>Budget (INR)</span>
                <div className="flex flex-wrap gap-2 mt-2">
                  {BUDGETS.map((b) => (
                    <button type="button" key={b} onClick={() => setBudget(b)} className={`chip ${budget === b ? "chip--active" : ""}`} style={{ height: 32, fontSize: 10 }} data-testid={`budget-${b}`}>{b}</button>
                  ))}
                </div>
              </div>
              <label className="block">
                <span className="mono" style={{ color: "var(--grey)" }}>Message</span>
                <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={4} className="w-full bg-transparent outline-none py-2" style={{ borderBottom: "1px solid var(--rule)", fontSize: 16, resize: "vertical" }} data-testid="input-message" />
              </label>
              <div className="flex items-center justify-between">
                <span className="mono" style={{ color: "var(--grey)" }}>Saved as draft · {remaining} field{remaining !== 1 ? "s" : ""} left</span>
                <button type="submit" className="btn btn--lime" disabled={status === "sending"} data-testid="submit-brief">{status === "sending" ? "Sending…" : "Send file →"}</button>
              </div>
              {status === "error" && errMsg && <p className="mono" style={{ color: "#c0392b" }}>{errMsg}</p>}
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
